/* eslint-disable */
import Hunt from "huntjs";
import { get } from "lodash";

const lazyImages = document.querySelectorAll(".js-image");

const matchImageStyle = (style) => {
  if (window.matchMedia("(min-width: 740px)").matches) {
    return style;
  }

  return "medium";
};

const loadImage = (image) => {
  const size = matchImageStyle(image.dataset.size);
  const newSrc = get(image.dataset, size);

  if (image.src !== newSrc) {
    // eslint-disable-next-line no-param-reassign
    image.src = newSrc;
    // eslint-disable-next-line no-param-reassign
    image.onload = () => {
      image.classList.remove("is-loading");
      image.classList.add("is-loaded");
    };

    image.onerror = () => {
      image.classList.remove("is-loading");
      image.classList.add("is-loaded");
      image.classList.add("is-error");
    };
  }
};

const loadImages = () => {
  // eslint-disable-next-line no-unused-vars
  const observer = new Hunt(lazyImages, {
    offset: 1200,
    enter: (image) => {
      loadImage(image);
    },
  });
};

window.addEventListener("load", () => {
  loadImages();
});

window.addEventListener("resize", () => {
  loadImages();
});
